export default "__VITE_ASSET__BIZ1Z4tF__"